routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.myPaymentsDetail', {
      url: "/mis-pagos/detalle/{paymentId}",
      template: `<my-payments-detail sh-ctrl="shCtrl"></my-payments-detail>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/pay-zone/my-payments/my-payments-detail/my-payments-detail.config.js
 **/